module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p13s1Title":"Internship Contract: Questions and Answers"},"es":{"p13s1Title":"Contrato de becario: preguntas y respuestas"}}')
  delete Component.options._Ctor
}
